import { render } from "./SuccessTransactionView.vue?vue&type=template&id=421a7f30"
import script from "./SuccessTransactionView.vue?vue&type=script&lang=js"
export * from "./SuccessTransactionView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__